module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"Pagination":{"ariaLabel":"Stránkování","buttonLoadMore":{"ariaLabel":"Zobrazit další produkty","text":"Zobrazit další"},"next":"Další","previous":"Zpět"}},"en":{"Pagination":{"ariaLabel":"Pagination","buttonLoadMore":{"ariaLabel":"Show more products","text":"Next"},"next":"Next","previous":"Back"}}}')
  delete Component.options._Ctor
}
